import React from 'react';
import { getCmtaLinks } from '@clubmed/domains-service';
import Grid from 'Components/frameworks/grid/Grid';
import { Product } from 'Components/widgets/product/Product';
import type { ProductProps } from 'Components/widgets/product/Product.utils';
import { useAppContext } from 'Context/ReactAppContext';
import {
  sortProductsByChildcareAvailability,
  sortProductsByPrice,
} from 'Utils/products/productsUtils';
export type ResortGridProps = {
  departureCity?: string;
  departureDateEnd?: string;
  departureDateStart?: string;
  displayPrices?: boolean;
  duration?: number;
};
export type Props = {
  childrenClassName?: string;
  className?: string;
  departureCity?: string;
  departureDateEnd?: string;
  departureDateStart?: string;
  display?: ScreenSizesProps;
  duration?: number;
  fetchData?: (arg0: string) => void;
  grid?: ScreenSizesProps;
  hasSeeMore: boolean;
  isLoading?: boolean;
  isSynchronousGrid?: boolean;
  lineName?: string;
  offer?: Offer;
  onComparisonClick?: (id: string) => unknown;
  orderByChildcareAvailability?: boolean;
  orderByPrice?: 'asc' | 'desc';
  products: ReadonlyArray<ProductProps>;
  seeMore?: SeeMoreProps;
  totalNumberToDisplay?: number;
};
export const ProductsGrid = ({
  childrenClassName,
  className,
  display,
  fetchData,
  grid,
  hasSeeMore,
  isLoading,
  isSynchronousGrid = false,
  lineName,
  offer,
  onComparisonClick,
  orderByChildcareAvailability = false,
  orderByPrice,
  products,
  seeMore,
  totalNumberToDisplay,
}: Props) => {
  const appContext = useAppContext();

  if (products.length === 0) {
    return null;
  }

  const cmtaLinks = getCmtaLinks(appContext.locale);
  let productListSorted;

  if (orderByChildcareAvailability) {
    productListSorted = sortProductsByChildcareAvailability(products, orderByPrice);
  } else {
    productListSorted = orderByPrice ? sortProductsByPrice(products, orderByPrice) : products;
  }

  return (
    <Grid
      className={className}
      childrenClassName={childrenClassName}
      display={display || grid}
      getChildren={fetchData}
      grid={grid}
      hasSeeMore={hasSeeMore}
      isLoading={isLoading}
      seeMore={seeMore}
      totalNumberToDisplay={totalNumberToDisplay}
      isSynchronousGrid={isSynchronousGrid}
    >
      {productListSorted.map((product, index) => (
        <Product
          cmtaLinks={cmtaLinks}
          index={index}
          key={product.id}
          lineName={lineName}
          offer={offer}
          onComparisonClick={onComparisonClick ? () => onComparisonClick(product.id) : undefined}
          {...product}
        />
      ))}
    </Grid>
  );
};
ProductsGrid.defaultProps = {
  hasSeeMore: false,
  products: [],
};
